import React from 'react';
import { withSvg } from './Svg';

const SvgCalendar = () => (
  <path d="M12.334 2.00033H11.6673V0.666992H10.334V2.00033H3.66732V0.666992H2.33398V2.00033H1.66732C0.933984 2.00033 0.333984 2.60033 0.333984 3.33366V14.0003C0.333984 14.7337 0.933984 15.3337 1.66732 15.3337H12.334C13.0673 15.3337 13.6673 14.7337 13.6673 14.0003V3.33366C13.6673 2.60033 13.0673 2.00033 12.334 2.00033ZM12.334 14.0003H1.66732V6.66699H12.334V14.0003ZM12.334 5.33366H1.66732V3.33366H12.334V5.33366Z" />
);

export default withSvg(20, 20)(SvgCalendar);
